import { parseParams } from './channels';
import { updateDropdownMenuPositionInExtendedFilters, initializeEngagementSliders } from './filter_helpers';
$(document).on('turbolinks:load', function() {

  $(".saved-search-li").hover(function(){
    let savedSearchId = $(this).data("savedSearchId");
    $(".a-actions-saved-search-"+savedSearchId).removeClass("opacity-0").addClass("opacity-100");
    }, function(){
    let savedSearchId = $(this).data("savedSearchId");
    $(".a-actions-saved-search-"+savedSearchId).removeClass("opacity-100").addClass("opacity-0");
  });

  $(".edit-saved-search-link").click(function() {
    let savedSearchId = $(this).data('savedSearchId');
    $.ajax({
      type: "GET",
      url: "/saved_searches/"+savedSearchId+"/edit",
      dataType: "script"
    });    
  });

  initializeEngagementSliders()

  $(".translation_missing").each(function(){
    $(this).css('background-color', 'red');
  })

  updateDropdownMenuPositionInExtendedFilters();

  $('#collapseFilters').on('shown.bs.collapse', function () {
    // TODO: determine if this should stay in here
    updateDropdownMenuPositionInExtendedFilters();
    $("#toggleCollapseBtn").addClass("bs-primary")
    $("#toggleCollapseBtn").removeClass("bs")
    $("#toggleCollapseBtn").removeClass("btn-outline-secondary")
  })

  $('#collapseFilters').on('hidden.bs.collapse', function () {
    updateDropdownMenuPositionInExtendedFilters();
    $("#toggleCollapseBtn").removeClass("bs-primary")
    $("#toggleCollapseBtn").addClass("bs")
    $("#toggleCollapseBtn").addClass("btn-outline-secondary")
  })

  setCustomDates();
  setObservedCustomDates();

  $(".post-labelling .label-container .label-children.hide-child").hide();
  $(".tag-edit").hide();

  $('body').on("keyup", "#filterTextBox", function () {
    var search = $(this).val().trim().toLowerCase();
    $(".checkbox-li").each(function () {
      if ($(this).text().toLowerCase().indexOf(search) < 0){
        $(this).hide()
      } else {
        $(this).show()
        $(this).children('ul')?.first()?.addClass('show')
        }
    })
  });

  $('#advanced-filters-button').on('click', function(){
    if ($('#advanced-filters').prop('className').includes('d-none')){
      $('#advanced-filters').removeClass('d-none').addClass('d-flex')
    } else {
      $('#advanced-filters').removeClass('d-flex').addClass('d-none')
    }
  })

  $('body').on('click', function (e) {
    if (!$('div.monitoring-array-dropdowns').is(e.target) 
        && $('div.monitoring-array-dropdowns').has(e.target).length === 0 
        && $('.open').has(e.target).length === 0
    ) {
      $('div.monitoring-array-dropdowns').removeClass('open');
    }
  });

  $('form#post-save-search-form').submit(function(e) {
    $('#save-search-query-field').val(JSON.stringify(parseParams(window.location.search)));
  });

  function setCustomDates(){
    let url = new URLSearchParams(window.location.search)

    if (window.location.search.includes("post_filters%5Bpublished_at_to")) {
      $('input[name="customDates"]').prop('checked', true)
      $('#getDates').show();
      $('#dateFrom').val(url.get('post_filters[published_at_from]'))
      $('#dateTo').val(url.get('post_filters[published_at_to]'))
    } else if (window.location.search.includes("last_collected_at_to")) {
      $('input[name="customDates"]').prop('checked', true)
      $('#getDates').show();
      $('#dateFrom').val(url.get('last_collected_at_from'))
      $('#dateTo').val(url.get('last_collected_at_to'))
    } else if (window.location.search.includes("published_at_to")){
      $('input[name="customDates"]').prop('checked', true)
      $('#getDates').show();
      $('#dateFrom').val(url.get('published_at_from'))
      $('#dateTo').val(url.get('published_at_to'))
    } else if (window.location.search.includes("Last")){
      $('#getDates').hide();
      $("#custom-field-container").on('click', function(){
        $('input[name="customDates"]').prop('checked', true)
        $('input[name="labelName"]').prop('checked', false)
        $('#getDates').show();
        $('#dateFrom').val(url.get("published_at_from"))
      });
    }
    else {
      $('#getDates').hide();
    }
  }

  $(".video-duration-filter #video_duration_range").change(function(){
    $('.video-duration-filter #rangeval').html($(this).val())
    let url = new URL(window.location.href);


    url.searchParams.set('video_duration', event.target.value*60)
    window.location.href = url.href; 
  });

  $(".confirm-btn").click(function(e) {
    e.preventDefault();

    if (confirm('Click OK to request a CSV file for this data to be sent to you via email.')){
      $(this).addClass( "disabled" );
    }
    else {
      return false;
    }
  })

  $("#channels_csv_export").click(function(e) {
    e.preventDefault();

    if (confirm('Click OK to request a CSV file for this data to be sent to you via email.')){
      $(this).addClass( "disabled" );
    }
    else {
      return false;
    }
  })

  $("#search-term-btn").click(function(){
    let url = new URL(window.location.href);

    if($('#search-term-text').val()){
      var val = $('#search-term-text').val()
      url.searchParams.set('term', val)

    } else {
      url.searchParams.delete('term')
    }

    window.location.href = url.href;
  });

  $('#search-term-text').keypress(function(e){
    let url = new URL(window.location.href);

    if(e.which == 13){

      var simple_query_checkbox = $('#query_string_checkbox')

      if(simple_query_checkbox) {
        if(simple_query_checkbox.prop('checked')){
          url.searchParams.set('simple_query', true)
        } else {
          url.searchParams.delete('simple_query')
        }
      }

      if($('#search-term-text').val()){
        var val = $('#search-term-text').val()
        url.searchParams.set('term', val)
  
      } else {
        url.searchParams.delete('term')
      }
      
      window.location.href = url.href;
    }
  });
  
  $('#userSelect').change(function(){
    let url = new URL(window.location.href);

    if($(this).val()){
      var val = $(this).val()
      url.searchParams.set('user', val)

    } else {
      url.searchParams.delete('user')
    }

    window.location.href = url.href;
  });

  $('#listSelect').change(function(){
    let url = new URL(window.location.href);

    if($(this).val()){
      var val = $(this).val()
      url.searchParams.set('list', val)

    } else {
      url.searchParams.delete('list')
    }

    window.location.href = url.href;
  });

  $('#platformSelect').change(function(){
    let url = new URL(window.location.href);

    if($(this).val()){
      var val = $(this).val()
      url.searchParams.set('platform_name', val)

    } else {
      url.searchParams.delete('platform_name')
    }

    window.location.href = url.href;
  });

  $('body').on("change",'.select-all-checkboxes', function(){
    var checkbox_container = $(this).parents(".check-dropdown")

    if ($(this).is(":checked")){
      checkbox_container.find('input[type="checkbox"]:visible').prop('checked', true)
    }
    else {
      checkbox_container.find('input[type="checkbox"]:visible').prop('checked', false)
    }
  });

  $("body").on('click', '.dynamic-filter-dropdown .dropdown-menu', function (e) {
    e.stopPropagation();
  });

  $("body").on('click', '.attribute-selector .dropdown-menu', function (e) {
    e.stopPropagation();
  });

  $('#all_platforms').on("click",function(){
    let params = new URLSearchParams(window.location.search)
    params.delete("platform_name[]")
    // $('.customselect:checked').each(function() {
    //   params = params + "&platform_name[]=" + $(this).val();
    // });
    params = new URLSearchParams(params)
    window.location.href = window.location.href.split('?')[0] + '?' + params
  });

  $('.customselect').on("change",function(){
    let params = new URLSearchParams(window.location.search)
    params.delete("platform_name[]")
    $('.customselect:checked').each(function() {
      params = params + "&platform_name[]=" + $(this).val();
    });
    params = new URLSearchParams(params)
    window.location.href = window.location.href.split('?')[0] + '?' + params
  });

  $('input[name="customDates"]').on('change', function(){
    if ($(this).is(":checked")){
      $('input[name="labelName"]').prop('checked', false)
      $('#getDates').show();
    }
    else {
      $('#getDates').hide();
    }
  });

  $("#custom-field-container").on('click', function(event){
    $('input[name="customDates"]').attr('checked', 'checked');
    $('input[name="labelName"]').prop('checked', false)
    $("#custom-field-container").parent().show();
    $('#getDates').show();
    event.stopPropagation();
  });

  $('#applyCustomDate' ).on('click', function(){
    setDateFields($(this).data("param-name"));
  });

  function setDateFields(param_name){
    var date_from = $('#dateFrom').val()
    var date_to = $('#dateTo').val()
    if (!date_to){
      date_to = new Date()
    }

    if (date_to != '' && date_from != '') {
      const params = new URLSearchParams(window.location.search)

      if(param_name=="published_at" && location.pathname == "/channels"){
        params.set(`post_filters[${param_name}_from]`, date_from)
        params.set(`post_filters[${param_name}_to]`, date_to)
      } else {
        params.set(`${param_name}_from`, date_from)
        params.set(`${param_name}_to`, date_to)
      }
      window.location.href = window.location.pathname + '?' + params;
    }
  }

  $('input[name="published_at_from"]').on('change', function(){
    if ($(this).is(":checked")){
      $('input[name="issueCustomDates"]').prop('checked', false)
      $('#getDates').hide();
    } else {
      $('#getDates').show();
    }
  });

  $("#issue-custom-field-container").on('click', function(event){
    $('input[name="issueCustomDates"]').attr('checked', 'checked');
    $('input[name="published_at_from"]').prop('checked', false)
    $("#issue-custom-field-container").parent().show();
    $('#getDates').show();
    event.stopPropagation();
  });

  $('body').on("change", '.post-labelling .tag-label', function(e) {
    e.preventDefault();

    if ($(this).find("input").prop('checked')) {
      $(this).parents(".label-container:first").find(".label-children:first").show();
    } else {
      $(this).parents(".label-container:first").find(".label-children input").prop('checked', false)
      $(this).parents(".label-container:first").find(".label-children .tag-label").removeClass('active')
      $(this).parents(".label-container:first").find(".label-children").hide();
      $(this).parents(".label-container:first").find(".label-children:first").hide();
    }
  });

  $('body').on('click', '.edit-labels-btn', function(){
    $(this).parents(".form-container").find(".tag-display").hide();
    $(this).parents(".form-container").find(".tag-edit").show();
    $(this).prop('disabled', true)
  })

  $("body").on('submit', 'form#post-list-save-search-form', function(e) {
    const params = new URLSearchParams(window.location.search);
    const paramsObj = {};
    for (const key of params.keys()) {
        if (params.getAll(key).length > 1) {
          paramsObj[key.replace('[]', '')] = params.getAll(key);
        } else if (key.includes('[]')) {
          paramsObj[key.replace('[]', '')] = params.getAll(key);
        }
        else {
          paramsObj[key] = params.get(key);
        }
    }
    $('#post-list-search-query-field').val(JSON.stringify(paramsObj));
    $('#post-list-search-query-field-redirect').val(JSON.stringify(parseParams(window.location.search)));
  });

  $('#savePostListModal').on('show.bs.modal', function() {
    $(this).find('.modal-body').html('<div class="text-center p-4"><i class="fas fa-spinner fa-spin"></i> Loading...</div>');
    
    $.ajax({
      url: '/post_lists/modal_form',
      type: 'GET',
      dataType: 'script'
    });
    
  });

  $('input[name="observedCustomDates"]').on('change', function(){
    if ($(this).is(":checked")){
      $('input[name="ObservedlabelName"]').prop('checked', false)
      $('#getObservedDates').show();
    }
    else {
      $('#getObservedDates').hide();
    }
  });

  $("#observed-custom-field-container").on('click', function(event){
    $('input[name="observedCustomDates"]').attr('checked', 'checked');
    $('input[name="ObservedlabelName"]').prop('checked', false)
    $("#observed-custom-field-container").parent().show();
    $('#getObservedDates').show();
    event.stopPropagation();
  });

  $('#applyObservedCustomDate' ).on('click', () => setObservedDateFields());

  function setObservedDateFields(){
    var date_from = $('#observedDateFrom').val()
    var date_to = $('#observedDateTo').val()
    if (!date_to){
      date_to = new Date()
    }

    if (date_to != '' && date_from != '') {
      const params = new URLSearchParams(window.location.search)
      params.set('observed_at_from', date_from)
      params.set('observed_at_to', date_to)
      window.location.href = window.location.pathname + '?' + params;
    }
  }

  function setObservedCustomDates(){
    if (window.location.search.includes('observed_at_to')) {
      $('input[name="observedCustomDates"]').prop('checked', true)
      $('#getObservedDates').show();
      let url = new URLSearchParams(window.location.search)
      $('#observedDateFrom').val(url.get('observed_at_from'))
      $('#observedDateTo').val(url.get('observed_at_to'))
    } else if (window.location.search.includes("Last")){
      $('#getObservedDates').hide();
      $("#observed-custom-field-container").on('click', function(){
        $('input[name="observedCustomDates"]').prop('checked', true)
        $('input[name="ObservedlabelName"]').prop('checked', false)
        $('#getObservedDates').show();
        let url = new URLSearchParams(window.location.search)
        $('#observedDateFrom').val(url.get("observed_at_from"))
      });
    } else {
      $('#getObservedDates').hide();
    }
  }

});

